import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {ProductService} from '../../../Services/product.service';
import {Product} from '../../../Models/Product';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {DButton, IButton} from '../../../../shared/card/card.component';
import {TranslateService} from '@ngx-translate/core';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {environment} from '../../../../../environments/environment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {Helper} from '../../../../helpers/helper.service';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/product/import?file=resource.file';

@Component({
  selector: 'app-product-overview',
  templateUrl: './product-overview.component.html',
  styleUrls: ['./product-overview.component.scss']
})
export class ProductOverviewComponent implements OnInit {
  public specialButton: IButton[] = [];
  public grid: Grid;
  public params;
  public productId: number;
  public productName: string;
  public specialButtonArray;
  public isUploading: boolean;
  private addFileItem: boolean;
  private isNotAdd = false;
  private target: any;
  public messages: string[] = [];
  public uploader: FileUploader = new FileUploader({
    // itemAlias: 'image',
    url: URL,
    authToken: this.auth.getBearerHeader(),
    allowedFileType: ['xlsx', 'xls', 'csv']
  });

  @ViewChild('collectionRowDetail', {static: true}) collectionRowDetail: any;
  @ViewChild('priceTemp', {static: true}) priceTemp;
  @ViewChild('customerPriceTemp', {static: true}) customerPriceTemp;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('importModal', {static: false}) importModal;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  @ViewChild('importResultModal', {static: false}) importResultModal;
  public dropdownItemsList: any[];
  public dropdownButton: DButton;
  selectedFile: any;

  constructor(private router: Router,
              private productService: ProductService,
              private broadCastService: BroadcastService,
              private translate: TranslateService,
              private auth: AuthenticationService,
              private helper: Helper,
              private authService: AuthenticationService,
  ) {
  }


  ngOnInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
      this.uploadElRef.nativeElement.value = '';
      if (this.target) {
        this.target.value = '';
      }
    });
    this.specialButtonArray = [
      {name: 'Import', btnIcon: '', method: 'import', customClass: 'btn-primary'},
      {name: 'Add', btnIcon: 'feather icon-plus', btnUrl: '/back-office/product/add', method: 'add', customClass: 'btn-primary'}
    ];
    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass,
      });
    });
    this.dropdownItemsList = [
      {
        btnName: this.translate.instant('admin.order.export.dropdown_layout_1'),
        method: 'export',
        key: Product.layout_1
      },
      {
        btnName: this.translate.instant('admin.order.export.dropdown_layout_2'),
        method: 'export',
        key: Product.layout_2
      },
    ];
    this.dropdownButton = {
      name: this.translate.instant('admin.order.export'),
      dropdownItems: [...this.dropdownItemsList]
    };
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.product.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          width: 180,

          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.model.model',
          prop: 'models',
          type: TextColumn.type,
          width: 150,
          minWidth: 100,
          maxWidth: 200,
          translate: true,
          valueFormatter: row => {
            const items = [];
            row.forEach(item => {
              items.push(item.name);
            });
            return items.join(',');
          },
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.number',
          prop: 'number',
          type: TextColumn.type,
          width: 130,
          minWidth: 130,
          maxWidth: 200,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.dealer_price',
          prop: 'dealerPrice',
          type: TextColumn.type,
          width: 100,
          minWidth: 100,
          maxWidth: 200,
          translate: true,
          valueTemplate: this.priceTemp,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.customer_price',
          prop: 'customerPrice',
          type: TextColumn.type,
          width: 100,
          minWidth: 100,
          maxWidth: 200,
          translate: true,
          valueTemplate: this.customerPriceTemp,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.type',
          prop: 'hasProduct',
          type: TextColumn.type,
          width: 110,
          minWidth: 110,
          maxWidth: 200,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant('admin.product.grouped_product');
            }
            return this.translate.instant('admin.product.product');
          },
        },
        <TextColumn>{
          name: 'doctrine.product.status',
          prop: 'status',
          type: TextColumn.type,
          width: 80,
          minWidth: 80,
          maxWidth: 100,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant('global.active');
            }
            return this.translate.instant('global.inactive');
          },
          responsiveHideCallback: (width) => width < 1024
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/product/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/product/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.productId = row.id;
                this.productName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.productService,
      rememberURL: this.router.url,
      method: 'getProduct',
      defaultSort: 'parentPosition',
      rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'model_id',
          type: 'ng-select',
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          value: new ServiceSearchItem(this.productService, 'getModals', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translate.instant('global.all')});
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
    };

  }

  public softDelete() {
    this.productService.softDeleteProduct(this.productId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getProduct');
    });
  }

  calFunction(method: string) {
    this[method]();
  }

  import() {
    this.importModal.show();
  }

  export(layout) {
    this.params = this.params.append('layout', layout.key);
    this.productService.exportProducts(this.params).subscribe((res: {url: string, filename: string} | boolean) => {
      if (res && typeof res === 'object') {
        const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        el.setAttribute('href', res.url);
        el.setAttribute('download', res.filename);
        el.click();
      }
    });
  }

  setParams(event) {
    this.params = event;
  }

  add() {
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/product/archive');
  }

  uploadFile() {
    this.isUploading = true;
    this.isNotAdd = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      if ( status === 401) {
        return this.handle401Error();
      }
      this.isUploading = false;
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        this.importModal.hide();
        this.uploader.clearQueue();
        this.broadCastService.broadcast('refreshGrid', 'getProduct');
        this.messages = JSON.parse(response);
        this.importResultModal.show();
      }
    };
  }

  cancelUpload() {
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
    this.importModal.hide();
  }

  onFileSelected() {
    this.selectedFile = this.uploader.queue[0].file.rawFile;
  }
  resetUploader() {
    this.uploader.clearQueue();
    this.uploader.addToQueue([this.selectedFile]);
  }

  private handle401Error(): void {
    this.authService.refreshToken().subscribe((token) => {
      this.resetUploader();
      this.uploader.authToken = 'Bearer ' + token.token;
        this.uploadFile();
      }, error => {
        this.isUploading = false;
      }
    );
  }
}
